// extracted by mini-css-extract-plugin
export default {"root":"dashboard_root__UEagj","title":"dashboard_title__pT8Ms","dashboard-section":"dashboard_dashboard-section__lEyzo"};